import toString from 'lodash/toString'

const passwordValidator = require('password-validator')

const CATEGORY_MINIMUM = 3

const PASSWORD_CATEGORIES =
[
	'uppercase',
	'lowercase',
	'digits',
	'symbols',
]

const PASSWORD_MIN_LENGTH = 10

const PASSWORD_PERMUTATIONS =
[
	[ 'uppercase', 'lowercase', 'digits' ],
	[ 'uppercase', 'lowercase', 'symbols' ],
	[ 'lowercase', 'digits', 'symbols' ],
	[ 'uppercase', 'digits', 'symbols' ],
]

const PASSWORD_SCHEMAS = PASSWORD_PERMUTATIONS.reduce
(
	(collection, rules) =>
	{
		let schema = new passwordValidator()

		schema
			.is().min(PASSWORD_MIN_LENGTH)

		rules.forEach(rule => schema.has()?.[rule]())

		return collection.concat([ schema ])
	},
	[]
)

function passwordCheck(value)
{
	value = toString(value)

	const failures = [ ...new Set(PASSWORD_SCHEMAS.map(schema => schema.validate(value, { list: true })).flat(Infinity)) ]

	const fails  = (rule) => failures.includes(rule)
	const passes = (rule) => !fails(rule)

	if ( PASSWORD_CATEGORIES.filter(rule => !fails(rule)).length < CATEGORY_MINIMUM )
	{
		failures.push('categories')
	}

	const rules = Object.fromEntries
	(
		[ 'min', 'categories', ...PASSWORD_CATEGORIES ].map
		(
			rule => [ rule, passes(rule) ]
		)
	)

	return {
		result: rules.min && rules.categories,

		rules,
	}
}

export default passwordCheck